import { render, staticRenderFns } from "./CardDetailDrawer.vue?vue&type=template&id=a9c2e08c&scoped=true"
import script from "./CardDetailDrawer.vue?vue&type=script&lang=js"
export * from "./CardDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./CardDetailDrawer.vue?vue&type=style&index=0&id=a9c2e08c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c2e08c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9c2e08c')) {
      api.createRecord('a9c2e08c', component.options)
    } else {
      api.reload('a9c2e08c', component.options)
    }
    module.hot.accept("./CardDetailDrawer.vue?vue&type=template&id=a9c2e08c&scoped=true", function () {
      api.rerender('a9c2e08c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/welfare/cardDetail/components/CardDetailDrawer.vue"
export default component.exports